import { createDefaultTyrann } from '@apis/common';
import {
  friend,
  friendInvitation,
  friendInvitationsQueryParam,
  friendQueryError,
  friendQueryResponse,
  patchFriendInvitation,
  postFriendInvitation,
} from '@models/Friend';
import * as t from 'io-ts';
import * as h from 'tyrann-io';

export const friendApis = createDefaultTyrann({
  '/friend/': {
    delete: {
      query: t.type({
        contact_id: t.number,
      }),
      response: {
        204: t.unknown,
      },
    },
  },
  '/friend/search/': {
    get: {
      query: h.omittable(
        t.type({
          type: t.string,
          email: t.string,
          company_name: t.string,
        }),
      ),
      response: {
        200: friendQueryResponse,
        400: friendQueryError,
      },
    },
  },
  '/friend/inviting/': {
    get: {
      query: friendInvitationsQueryParam,
      response: {
        200: t.array(friendInvitation),
      },
    },
    post: {
      body: postFriendInvitation,
      response: {
        201: friend,
      },
    },
  },
  '/friend/invited/': {
    get: {
      response: {
        200: t.array(friendInvitation),
      },
    },
  },
  '/friend/invited/{id}/': {
    patch: {
      path: t.type({
        id: t.number,
      }),
      body: patchFriendInvitation,
      response: {
        200: friend,
      },
    },
    delete: {
      path: t.type({
        id: t.number,
      }),
      response: {
        204: t.literal(''),
      },
    },
  },
  '/friend/inviting/{id}/': {
    patch: {
      path: t.type({
        id: t.number,
      }),
      body: patchFriendInvitation,
      response: {
        200: friend,
      },
    },
    delete: {
      path: t.type({
        id: t.number,
      }),
      response: {
        204: t.literal(''),
      },
    },
  },
});
